import { render, staticRenderFns } from "./CreateActivity.vue?vue&type=template&id=54602342"
import script from "./CreateActivity.vue?vue&type=script&lang=js"
export * from "./CreateActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports